import { Component, OnInit, Inject } from '@angular/core';
import { DocumentService } from '../../services/document.service';
import { Observable } from 'rxjs/Observable';
import { Document } from '../../models/document';
import { Types, Type } from '../../models/types';
import { User } from '../../models/user';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import * as fromRoot from '../../common/appstore/index';
import * as layout from '../../common/appstore/actions';

@Component({
  selector: 'app-doc-choice',
  templateUrl: './doc-choice.component.html',
  styleUrls: ['./doc-choice.component.scss']
})
export class DocChoiceComponent implements OnInit {

  types: { string: Types } = null;
  document: Document;
  currentuser: User;
  selected_types: Array<Type>;
  selected_typeDoc: string; //key data


  constructor(
    private documentservice: DocumentService,
    private router: Router
  ) { }

  ngOnInit() {
    this.getTypeDoc();
    this.currentuser = JSON.parse(localStorage.getItem('currentuser'));
  }

  getTypeDoc() {
    this.documentservice.getStructureDocs().subscribe(data => {
      console.log("data", data);
      this.types = data;
    });
  }

  selectedType(typeDoc: string, type: Types) {
    console.log(type);
    this.selected_typeDoc = typeDoc;
    this.selected_types = type.confs;
  }

  saveDoc(type: string): void {
    this.documentservice.saveDocument(type, this.currentuser.id).subscribe(() => {
      this.router.navigate(['/steps', this.selected_typeDoc, type])
    });

  }

}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/doc-choice/doc-choice.component.ts